<template>
  <section class="section center">
    <div class="card success-card">
      <h1>🎉 Subscription successful</h1>

      <p>
        Your payment was successful. We're activating your account now.
      </p>

      <p class="muted">
        This may take a few munutes. You will be redirected automatically.
      </p>

      <div class="spinner"></div>

      <RouterLink class="button secondary" to="/companydashboard">
        Go to dashboard now
      </RouterLink>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import { BASE_URL } from '@/config';

const router = useRouter()
const API_URL = BASE_URL

async function checkStatus() {
  try {
    const jwt = localStorage.getItem('jwt')

    const response = await axios.get(
      `${API_URL}/api/users/me`,
      {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      }
    )

    const user = response.data

    // update local storage
    localStorage.setItem('user', JSON.stringify(user))

    if (user.subscriptionstatus === 'active') {
      router.push('/companydashboard')
    } else {
      // retry after delay
      setTimeout(checkStatus, 2000)
    }
  } catch (err) {
    console.error('Status check failed', err)
    setTimeout(checkStatus, 3000)
  }
}

onMounted(() => {
  checkStatus()
})
</script>
